import { actions } from '../reducer';

import { fetchInitiatives } from './api.service';

const {
  getInitiativesRequest,
  getInitiativesSuccess,
  getInitiativesFailure,
  setInitiativeId,
  setInitiativeResolved,
} = actions;

export const setInitiative = (initiativeId) => async (dispatch) => {
  try {
    sessionStorage.setItem('initiative_id', initiativeId);
    dispatch(setInitiativeId({ initiativeId: String(initiativeId) }));
  } catch ({ message }) {
    console.log(message);
  }
};

export const fetchInitiativesForSelect = () => async (dispatch) => {
  try {
    dispatch(getInitiativesRequest());
    const { data } = await fetchInitiatives({ perPage: 999, page: 1 });
    dispatch(
      getInitiativesSuccess({
        initiatives: data.data,
      }),
    );
  } catch ({ message }) {
    dispatch(getInitiativesFailure(message));
  }
};

/**
 * Resolves the initial initiative: the initiative_id in sessionStorage (the user's last selection,
 * or a URL deep link copied in at app boot), otherwise the first active initiative by campaign
 * name. Marks the initiative as resolved even when the user has no initiatives, so dependent
 * fetches can proceed.
 *
 * @returns {Promise<string|null>} The resolved initiative id, or null if none could be resolved.
 */
export const initializeInitiative = () => async (dispatch, getState) => {
  await dispatch(fetchInitiativesForSelect());

  const storedInitiativeId = sessionStorage.getItem('initiative_id');
  const firstActiveInitiative = getState()
    .globalSelections.initiatives.filter(({ is_active }) => is_active)
    .sort((a, b) => a.campaign_name.localeCompare(b.campaign_name))[0];

  const initiativeId =
    (storedInitiativeId !== '0' && storedInitiativeId) || firstActiveInitiative?.id;

  if (initiativeId) {
    await dispatch(setInitiative(initiativeId));
  }
  dispatch(setInitiativeResolved());

  return getState().globalSelections.initiativeId;
};
